<template>
  <f7-page :page-content="true">
    <f7-navbar :back-link="$t('atras')">
      <f7-nav-title v-if="id && !readonly" sliding>Editar SWIFT</f7-nav-title>
      <f7-nav-title v-else-if="id" sliding>SWIFT</f7-nav-title>
      <f7-nav-title v-else sliding>Nuevo SWIFT</f7-nav-title>
      <f7-nav-right>
        <f7-button v-if="!readonly" fill icon-f7="floppy_disk" text="Guardar" class="display-flex" @click="$refs.rform.saveItem()"></f7-button>
        <template slot="right" v-else>
          <f7-button color="blue" @click="readonly=false">Editar</f7-button>
          <f7-button color="red" @click="deleteItem">Eliminar</f7-button>
        </template>
      </f7-nav-right>
    </f7-navbar>

    <r-form ref="rform" v-slot="{rform}" :itemId="id" @save="onSave" :readonly="readonly" :dbAdapter="SwiftCache">
      <f7-card class="padding-vertical-half padding-right" style="z-index: 3000">
        <f7-card-content>
          <f7-row no-gap class="list list-form no-hairlines">
            <f7-col width="100" medium="50">
              <ul>
                <r-input floating-label label="Código Banco" :form="rform" type="text" name="codigoBanco"></r-input>
                <r-input floating-label label="SWIFT" :form="rform" type="text" name="swift"></r-input>
                <r-input floating-label label="Nombre Banco" :form="rform" type="text" name="nombreBanco"></r-input>
              </ul>
            </f7-col>
          </f7-row>
        </f7-card-content>
      </f7-card>
      <pre style="display:none;">{{rform.formData}}</pre>
    </r-form>
  </f7-page>
</template>

<script>
import rForm from "./../../components/rForm.vue";
import rInput from "./../../components/rInput.vue";
import SwiftCache from "./../../js/db/SwiftCache.js";

export default {
  components: { rForm, rInput },
  data: function() {
    return {
      SwiftCache,
      readonly: !this.editable
    };
  },
  props: {
    id: {
      type: String
    },
    editable: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    deleteItem: function() {
      var self = this;
      var app = self.$f7;
      app.dialog.confirm(
        self.$t("rlist.pregunta_eliminar_registro"),
        "Eliminar",
        function() {
          SwiftCache.delete({itemId: self.id}).then(function(res) {
            if (res) {
              app.toast.create({
                icon: '<i class="f7-icons">checkmark</i>',
                text: self.$t("rlist.registro_eliminado"),
                position: "center",
                destroyOnClose: true,
                closeTimeout: 2000
              }).open();
              self.$f7router.back();
            }
          }).catch(function(error){
            app.dialog.alert(error.message);
          });
        }
      );
    },
    onSave: function(res) {
      var self = this;
      var app = self.$f7;
      self.$refs.rform.formData = res;
      self.readonly = true;
      app.toast.create({
        text: "Código SWIFT guardado",
        position: "center",
        closeTimeout: 2000,
        icon: '<i class="f7-icons">checkmark_alt</i>'
      }).open();
    }
  }
};
</script>
